import {
  Component,
  OnInit,
  HostListener,
  Inject,
  PLATFORM_ID
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Stockitem } from '../../../../interfaces/stockitem';
import { CartService } from '../../../../services/cart';
import { AdvancedStocksService } from '../../../../services/advancedstocksservice';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { UrlSlugifyService } from '../../../../services/url-slugify';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-productsbypet',
  templateUrl: './productsbypet.component.html',
  styleUrl: './productsbypet.component.scss'
})
export class ProductsbypetComponent implements OnInit {

  allData: Stockitem[] = [];
  totalItems = 0;
  stockTotal: any;

  contentReady = true;
  noData = false;

  page = 1;
  itemsCount = 9;

  isAr = false;
  isMobile = false;

  petId!: any;
  catagoryId: any = null;
  price: any = null;

  activeCategory: number | null = null;
  activeLimit: number | null = null;

  private isBrowser: boolean;

  constructor(
    private router: Router,
    private deviceService: DeviceDetectorService,
    private _advancedStocks: AdvancedStocksService,
    private cartService: CartService,
    private route: ActivatedRoute,
    private _slugify: UrlSlugifyService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    if (!this.isBrowser) {
      return;
    }

    this.isMobile = this.deviceService.isMobileDevice();
    this.itemsCount = this.isMobile ? 8 : 9;
    this.isAr = localStorage.getItem('language') === 'ar';

    this.route.params.subscribe(params => {
      this.petId = params['id'];
      this.page = 1;
      this.catagoryId = null;
      this.price = null;
      this.activeCategory = null;
      this.activeLimit = null;

      if (this.petId) {
        this.getProductsByPet();
      }
    });
  }

  selectCategory(category: number | null): void {
    this.activeCategory = category;
    this.catagoryId = category;
    this.page = 1;
    this.getProductsByPet();
  }

  selectLimit(limit: number): void {
    this.activeLimit = limit;
    this.price = limit;
    this.page = 1;
    this.getProductsByPet();
  }

  underPrice(price: any): void {
    this.price = price;
    this.page = 1;
    this.getProductsByPet();
  }

  getProductsByPetAndCatagory(catagoryId: any): void {
    this.catagoryId = catagoryId;
    this.page = 1;
    this.getProductsByPet();
  }

  getProductsByPet(): void {
    this.contentReady = true;

    this._advancedStocks
      .advancedStocks(
        1,
        this.page,
        this.itemsCount,
        {
          pet: this.petId,
          categoryId: this.catagoryId,
          maxPrice: this.price
        }
      )
      .subscribe({
        next: (res: any) => {
          this.allData = res.data;
          this.stockTotal = res.meta.total;
          this.totalItems = res.meta.last_page;

          this.noData = this.stockTotal === 0;
          this.contentReady = false;

          if (this.isBrowser) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        },
        error: (error) => {
          console.error(error);
          this.contentReady = false;
          this.noData = true;
        },
      });
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    if (!this.isBrowser || this.contentReady) return;

    const scrollPosition =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    const windowHeight = window.innerHeight;
    const pageHeight = document.documentElement.scrollHeight;

    const bottomReached =
      scrollPosition + windowHeight >= pageHeight - 10;

    if (this.page === 1) {
      this.page = 2;
    }

    if (bottomReached && this.page <= this.totalItems) {
      this.loadMore();
    }
  }

  private loadMore(): void {
    this.contentReady = true;

    this._advancedStocks
      .advancedStocks(
        1,
        this.page,
        this.itemsCount,
        {
          pet: this.petId,
          categoryId: this.catagoryId,
          maxPrice: this.price
        }
      )
      .subscribe({
        next: (res: any) => {
          this.allData = [...this.allData, ...res.data];
          this.page++;
          this.noData = this.allData.length === 0;
          this.contentReady = false;
        },
        error: (error) => {
          console.error(error);
          this.contentReady = false;
        },
      });
  }

  addToCart(product: any): void {
    if (!this.isBrowser) return;
    this.cartService.addToCart(product);
  }

  byPet(pet: any, petId: any): void {
    this.router.navigate(['/pet', pet, petId]);
  }

  productDetails(product: any): void {
    this.router.navigate([
      '/product',
      this._slugify.slugify(product.name_en),
      product.id
    ]);
  }

  calcDis(newP: any, oldP: any): number {
    const off = Math.round(
      ((parseInt(oldP, 10) - parseInt(newP, 10)) / parseInt(oldP, 10)) * 100
    );
    return isNaN(off) ? 0 : off;
  }
}
